// extracted by mini-css-extract-plugin
export default {"advertDetailHeader":"c-k_gJ"};